import { useStore } from 'vuex';

export const useCompanyCustom = () => {
  const store = useStore();
  return store.getters['layout/custom'];
};
